import { Component, OnInit, Input, OnDestroy, ChangeDetectorRef, ViewChild, TemplateRef } from "@angular/core";
import { Router } from "@angular/router";
import { NzModalRef, NzModalService } from "ng-zorro-antd/modal";
import { NzMessageService } from "ng-zorro-antd/message";
import { AccountService } from "@root/router/channel/account/account.service";
import { ErrorCode, PlatformType } from "@root/config";
import { Subscription } from "rxjs";
import { ModalService } from "@root/router/index/modal.service";
import { TranslateService } from "@root/shared/service/translate.service";
import { StoreService } from "@root/shared/service/store.service";
import { VrboLinkComponent } from "@root/router/channel/account/vrbo-link/vrbo-link.component";
import { DomSanitizer } from "@angular/platform-browser";

enum STATUS {
  LOADING = 0,
  SUCCESS = 1,
  ERROR = 2,
  LOCK = 3,
  VERIFY_CODE = 4,
  VERIFY_CODE_CAPTCHA = 5,
  ZHENGUO_VERIFY_TYPES = 10,
}

enum TYPE {
  LOGIN = 1,
  SYNC = 2,
}

enum LOCK_TYPE {
  AIRBNB = 1,
  CTRIP = 2,
  ZHENGUO = 3,
  MEITUAN = 4,
  AIRBNB_GEETEST = 11,
  AIRBNB_BROWSER_VERIFY = 12, // 爱彼迎浏览器验证
}

const loginModal = {
  loadingText: "channel.logging_in",
  successText: "channel.login_succeeded_continue_to_enter_account",
  failText: "channel.login_failed",
  failSubText: "channel.try_again_later",
};
// const loginModal = {
//   loadingText: '正在登录中...',
//   successText: '登录成功，是否继续录入账号？',
//   failText: '登录失败',
//   failSubText: '请稍后再试'
// };

// const syncModal = {
//   loadingText: '同步房源中...请勿关闭浏览器或刷新页面',
//   successText: '同步成功',
//   failText: '同步失败',
//   failSubText: '请点击重试按钮，重试一次'
// };

@Component({
  selector: "host-modal-request-status",
  templateUrl: "./modal-request-status.component.html",
  styleUrls: ["./modal-request-status.component.scss"],
})
export class ModalRequestStatusComponent implements OnInit, OnDestroy {
  readonly LockType: typeof LOCK_TYPE = LOCK_TYPE;
  @Input() id;
  @Input() thirdpartyType;
  @Input() tujia;
  @Input() muniao;
  @Input() meituan;
  @Input() username;
  status = STATUS.LOADING;
  type = TYPE.LOGIN;
  lockType = LOCK_TYPE.AIRBNB;
  /** 登录验证相关的信息 */
  airbnbGeetestPayload; // airbnb geetest滑块验证需要的信息
  airbnbBrowserVerifyInfo; // airbnb 浏览器验证需要的信息
  airlock;
  ctriplock;
  zhenguolock;
  verifyType;
  modal;

  inputCode = "";

  /** 榛果验证时填的值，除了短信验证码之外的其他的值 */
  zhenguoVerifyValue;
  sendBtnLoading = false;
  postBtnLoading = false;
  captchaToken = null;
  captchaUrl = null;
  captchaCode = "";

  // 抖音的滑块验证url
  douyinSliderIframeUrl;
  @ViewChild("douyinSliderIframe") douyinSliderIframe: TemplateRef<any>;

  subscription: Subscription;

  constructor(
    public router: Router,
    private subject: NzModalRef,
    private accountService: AccountService,
    private modalService: NzModalService,
    private cdr: ChangeDetectorRef,
    private globalModalService: ModalService,
    private storeService: StoreService,
    private messageService: NzMessageService,
    private translateService: TranslateService,
    private sanitizer: DomSanitizer,
  ) {}

  ngOnInit() {
    this.modal = loginModal;
    this.accountLogin();
  }

  /** @deprecated */
  pluginLogin() {
    this.accountService.pluginLogin(this.id);
    this.subject.destroy("onCancel");
  }

  //#region airbnb lock
  sendAirlockCode(type) {
    this.verifyType = type;
    this.status = STATUS.VERIFY_CODE;

    this.accountService
      .sendAirlockCode({
        id: this.id,
        airlock_id: this.airlock.airlock_id,
        verify_types: type,
      })
      .subscribe((res) => {
        console.log(res);
      });
  }

  postAirlockCode() {
    this.postBtnLoading = true;
    this.accountService
      .postAirlockCode({
        id: this.id,
        airlock_id: this.airlock.airlock_id,
        verify_types: this.verifyType,
        code: this.inputCode,
      })
      .subscribe(
        (res) => {},
        (err) => {
          this.cancel();
        },
        () => {
          this.confirm();
        },
      );
  }

  //#endregion

  //#region booking lock
  sendBookingCode(type) {
    const payload = this.ctriplock[type] && this.ctriplock[type][0];
    const id = payload && payload.id;
    this.verifyType = type;
    this.status = STATUS.VERIFY_CODE;
    this.accountService
      .sendBookingCode({
        id: this.id,
        phone_id: id,
        verify_type: type,
      })
      .subscribe((res) => {});
  }

  postBookingCode() {
    this.postBtnLoading = true;
    this.accountService
      .postBookingCode({
        id: this.id,
        code: this.inputCode,
      })
      .subscribe(
        (res) => {},
        (err) => {
          this.cancel();
        },
        () => {
          this.confirm();
        },
      );
  }

  //#endregion

  //#region meituan lock

  sendMeituanCode() {
    this.sendBtnLoading = true;
    this.accountService
      .sendMeituanCode({
        id: this.id,
        captcha_token: this.captchaToken,
        captcha_code: this.captchaCode,
      })
      .subscribe((res) => {
        console.log(res);
        this.sendBtnLoading = false;

        if (res?.data?.status?.toString() === "captcha") {
          this.status = STATUS.VERIFY_CODE_CAPTCHA;
          this.captchaToken = res?.data?.captcha_token;
          this.captchaUrl = res?.data?.captcha_url;
        } else if (res?.data?.status?.toString() === "success") {
          this.status = STATUS.VERIFY_CODE;
        }
      });
  }

  postMeituanCode() {
    this.postBtnLoading = true;
    this.accountService
      .postMeituanCode({
        id: this.id,
        code: this.inputCode,
        captcha_token: this.captchaToken,
        captcha_code: this.captchaCode,
      })
      .subscribe(
        (res) => {
          this.confirm();
        },
        (err) => {
          this.cancel();
        },
        () => {
          this.postBtnLoading = false;
          // this.confirm();
        },
      );
  }

  //#endregion

  //#region zhenguo lock
  sendZhenguoCode(type) {
    const payload = this.zhenguolock[type] && this.zhenguolock[type][0];
    const id = payload && payload.id;

    if (type === "sms") {
      this.verifyType = type;
      this.status = STATUS.VERIFY_CODE;
      this.accountService
        .sendZhenguoCode({
          id: this.id,
          phone_id: id,
          verify_type: type,
        })
        .subscribe((res) => console.log(res));
    } else {
      this.verifyType = type;
      this.status = STATUS.ZHENGUO_VERIFY_TYPES;
    }
  }

  postZhenguoCode() {
    this.postBtnLoading = true;

    let code;
    if (this.verifyType === "sms") {
      code = this.inputCode;
    } else {
      if (this.verifyType === "filledname") {
        const desc = this.zhenguolock.filledname[0].desc;
        code = desc.replace(/\*/, this.zhenguoVerifyValue[0] || "").replace(/\*/, this.zhenguoVerifyValue[1] || "");
        console.log(code);
      } else {
        code = this.zhenguoVerifyValue;
      }
    }

    this.accountService
      .postZhenguoCode({
        id: this.id,
        type: this.verifyType,
        // code: this.inputCode.join(''),
        code: code,
        phone_id: this.zhenguolock[this.verifyType][0].id,
      })
      .subscribe(
        (res) => {},
        (err) => {
          this.cancel();
        },
        () => {
          this.confirm();
        },
      );
  }

  //#endregion

  postCode() {
    if (this.lockType === LOCK_TYPE.AIRBNB) {
      this.postAirlockCode();
    } else if (this.lockType === LOCK_TYPE.CTRIP) {
      this.postBookingCode();
    }
  }

  loginAfterAirbnbBrowserVerify() {
    this.status = STATUS.LOADING;
    this.accountLogin();
    this.cdr.detectChanges();
  }

  /** 爱彼迎 geetest 滑块验证登录 */
  private airbnbLoginWithGeetestPayload() {}

  private accountLogin() {
    const params = { id: this.id };
    if (this.thirdpartyType === PlatformType.Airbnb && this.lockType === LOCK_TYPE.AIRBNB_GEETEST) {
      Object.assign(params, this.airbnbGeetestPayload);
    } else if (this.thirdpartyType === PlatformType.Airbnb && this.lockType === LOCK_TYPE.AIRBNB_BROWSER_VERIFY) {
      Object.assign(params, {
        verify_key: this.airbnbBrowserVerifyInfo.verify_key,
      });
    } else if (this.thirdpartyType === PlatformType.TuJia || this.thirdpartyType === PlatformType.Fliggy) {
      console.log("account login: transfer data: ", this.tujia);
      Object.assign(params, {
        verify_key: this.tujia?.verify_key,
        verify_code: this.tujia?.verify_code,
        verify_payload: this.tujia?.verify_payload,
      });
    } else if (this.thirdpartyType === PlatformType.Ctrip || this.thirdpartyType === PlatformType.Douyin) {
      Object.assign(params, {
        verify_key: this.tujia?.verify_key,
        verify_code: this.tujia?.verify_code,
      });
    } else if (
      this.thirdpartyType === PlatformType.MuNiao
      // this.thirdpartyType === PLATFORM_TYPE.FLIGGY
    ) {
      Object.assign(params, {
        verify_key: this.muniao.verify_key,
        verify_code: this.muniao.verify_code,
      });
    } else if (this.thirdpartyType === PlatformType.MeiTuanJiuDian) {
      Object.assign(params, {
        verify_key: this.meituan.verify_key,
        verify_code: this.meituan.verify_code,
        verify_payload: this.meituan ? this.meituan.verify_payload : null,
      });
    }
    console.log("login_params:", params);
    this.accountService.accountLogin(params).subscribe(
      (res) => {
        switch (res.error_code) {
          case ErrorCode.Success:
            this.status = STATUS.SUCCESS;
            // airbnb的浏览器验证如果第一次验证点击继续，未成功，需要提示，如果成功这里清空信息，便不再提示
            this.airbnbBrowserVerifyInfo = null;

            if (this.thirdpartyType === PlatformType.MeiTuanJiuDian) {
              this.storeService.set("meituan_delete_login_status", 1, 2);
            }

            break;
          case ErrorCode.AIRBNB_NEED_VERIFICATION_FOR_LOGIN:
            this.airlock = res.data.airlock || {};
            this.lockType = LOCK_TYPE.AIRBNB;
            this.status = STATUS.LOCK;
            break;
          case ErrorCode.AIRBNB_NEED_GEETEST_VERIFY_FOR_LOGIN:
            console.log("airbn geetest: ", res);
            this.airlock = res.data.airlock_id;
            this.status = STATUS.LOCK;
            if (res.data.geetest.china_captcha) {
              // 需要滑块的人机交互
              this.lockType = LOCK_TYPE.AIRBNB_GEETEST;
              const captcha = res.data.geetest.china_captcha;
              initGeetest(captcha, (ob) => {
                ob.appendTo(".airbnb-geetest-container");
                ob.onReady(() => {
                  console.log("ready");
                }).onSuccess(() => {
                  const result = ob.getValidate();
                  this.airbnbGeetestPayload = {
                    verify_key: captcha.challenge,
                    verify_payload: result,
                  };
                  this.status = STATUS.LOADING;
                  this.accountLogin();
                  this.cdr.detectChanges();
                  console.log("success, ", result);
                });
                // ob.getValidate();
                // ob.appendTo(t);
              });
            } else if (res.data.geetest.recaptcha) {
              if (this.airbnbBrowserVerifyInfo) {
                // 您需要先完成验证才可进入下一步
                const warningText = this.translateService.syncGet("channel.airbnb_need_browser_verify_again");
                this.messageService.warning(warningText);
              }
              // 需要去爱彼迎验证的人机交互
              this.lockType = LOCK_TYPE.AIRBNB_BROWSER_VERIFY;
              const captcha = res.data.geetest.recaptcha;
              this.airbnbBrowserVerifyInfo = {
                verify_key: captcha.verify_key,
                url: captcha.url,
              };
            }
            break;
          case ErrorCode.CTRIP_NEED_VERIFICATION_FOR_LOGIN:
            this.ctriplock = res.data.ctrip;
            this.lockType = LOCK_TYPE.CTRIP;
            this.status = STATUS.LOCK;
            break;
          // case ErrorCode.BOOKING_NEED_VERIFICATION_FOR_LOGIN:
          //   this.bookinglock = res.data.booking;
          //   this.lockType = LOCK_TYPE.BOOKING;
          //   this.status = STATUS.LOCK;
          //   break;
          case ErrorCode.ZHENGUO_NEED_VERIFICATION_FOR_LOGIN:
            this.zhenguolock = res.data.zhenguo;
            this.lockType = LOCK_TYPE.ZHENGUO;
            this.status = STATUS.LOCK;
            break;
          case ErrorCode.VRBO_NEED_VERIFICATION_FOR_LOGIN:
            const verifyData = {
              accountId: this.id,
              phoneId: res?.data?.vrbo?.call?.id,
            };
            this.tmp_displayVrboVerifyModal(verifyData);
            break;
          case ErrorCode.MEITUAN_NEED_VERIFICATION_FOR_LOGIN:
            this.zhenguolock = res.data.meituan;
            this.lockType = LOCK_TYPE.MEITUAN;
            this.status = STATUS.LOCK;
            break;
          case ErrorCode.DouyinNeedSliderVerify:
            this.status = STATUS.ERROR;
            this.modal.failSubText = res.error_msg;
            this.displayDouyinSliderVerifyIframe(res?.data?.douyin?.iframe_url);
            break;
          default:
            this.status = STATUS.ERROR;
            this.modal.failSubText = res.error_msg;
        }

        this.cdr.detectChanges();
      },
      (err) => (this.status = STATUS.ERROR),
    );
  }

  createAccount() {
    this.subject.destroy("onOk");
    this.accountService.displayCreateAccountModal({
      thirdpartyType: this.thirdpartyType,
    });
    // this.subject.destroy({
    //   type: 'create'
    // });
  }

  displayDouyinSliderVerifyIframe(url: string) {
    this.douyinSliderIframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);

    const modal = this.modalService.create({
      nzTitle: null,
      nzContent: this.douyinSliderIframe,
      nzFooter: null,
      nzWidth: 440,
    });

    const cb = (event) => {
      const data = event.data;
      if (typeof data === "string" && JSON.parse(data)?.type === "success") {
        modal.destroy();
        window.removeEventListener("message", cb);
        this.accountLogin();
      }
    };
    window.addEventListener("message", cb);
  }

  tmp_displayVrboVerifyModal(verifyData) {
    const modal = this.modalService.create({
      nzTitle: null,
      nzContent: VrboLinkComponent,
      nzFooter: null,
      nzWidth: 300,
      nzData: {
        verifyData,
      },
    });
    modal.afterClose.subscribe((rst) => {
      if (rst === "success") {
        this.subject.destroy();
      }
    });
  }

  toSync() {
    // this.subject.next({
    //   type: 'sync',
    //   data: this.id
    // });
    // this.subject.destroy();

    this.subject.destroy({
      type: "sync",
      data: this.id,
    });
  }

  cancel() {
    this.subject.triggerCancel();
    this.subject.destroy("onCancel");
  }

  confirm() {
    this.subject.triggerOk();
    this.subject.destroy("onOk");
  }

  displayCustomerModal() {
    this.globalModalService.displayCustomerServiceClient();
  }

  retry() {
    this.subject.destroy();
    this.accountService.displayReLoginModal({
      thirdpartyType: this.thirdpartyType,
      accountId: this.id,
      username: this.username,
    });
  }

  ngOnDestroy() {
    // tslint:disable-next-line:no-unused-expression
    this.subscription && this.subscription.unsubscribe();
  }
}
